import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation, ApprovalTypes } from 'ui-product-approvals-common';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalModalMessageLabelI18n = ({
  approvalType,
  currentOperation
}) => {
  if (currentOperation === ApprovalOperation.REQUEST) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalModalMessageLabel.REQUEST"
    });
  }
  if (approvalType === ApprovalTypes.DEAL && currentOperation === ApprovalOperation.REJECT) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalModalMessageLabel.DEAL"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.approvalModalMessageLabel.default"
  });
};
export const ApprovalModalMessageLabelHelpI18n = ({
  approvalType,
  currentOperation
}) => {
  if (approvalType === ApprovalTypes.DEAL && currentOperation === ApprovalOperation.REJECT) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalModalMessageLabelHelp.DEAL"
    });
  }
  return null;
};